import { CONSTANTS } from "client/utils/constants";
import { ITransferRequest } from "Model/IAssetAPIObjectRequestData";
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { createTransferRequest } from "Store/Transfer/Transfer/TransferOrderByIdAction";
import { getOnlyNumbers } from "client/utils/RequisitionUtil";
import { DispositionTypeRequiredAttachment } from "client/Components/OrderManagement/Asset/TransferOrder/CreateNewRequisition/Disposition/DispositionTypeAttachment";
import { formatPrice } from "utils";
import { setBillOfSaleUrl, setIsBillOfSaleCreated } from "Store/OrderManagement/BillOfSale/BillOfSaleAction";

const ReactToAPI = (props: any) => {
    const {
        orderDetails,
        getUserDetails,
        type,
        dispatch,
        docList,
        transferOrderNumber,
        transferRequests,
        dispositionCartList,
        assets,
        reactivationRequests,
        globalPenaltyFlag,
        billOfSaleUrl
    } = props;
    const apiObject: ITransferRequest = {
        orderId: 0,
        orderTypeId: 0,
        branchId: 0,
        userEmailId: "",
        savedBy: "",
        orderAction: "",
        attachments: [],
        isApprovalOverride: false,
        bosAttachment: null
    }
    apiObject.orderId = transferOrderNumber ? transferOrderNumber : 0;
    apiObject.orderAction = type;
    apiObject.orderTypeId = orderDetails.requestType.text;
    apiObject.isApprovalOverride = orderDetails?.isApprovalOverride;

    apiObject.userEmailId = getUserDetails?.emailId;
    apiObject.savedBy = getUserDetails?.emailId;
    apiObject.branchId = orderDetails.selectedBranch?.branchNo;
    apiObject.attachments = docList;
    apiObject.bosAttachment = billOfSaleUrl?.attachmentUrl ? billOfSaleUrl : null;

    const getAssetType = (asset?: any) => {
        if(asset.glCategory ==="Trailers"){
            return asset.glCategory
        }else{
            if(asset.isOdometerRequired){
                return "vehicle"
            }else{
                if(asset.glCategory?.toLowerCase()?.includes("mower")){
                    return "mower"
                }else{
                    return asset.glCategory
                }
            
            }
        }
    }

    //setting up the Asset data
    const getAssets = (tempRequest: any) => {
        return assets?.filter((asset: any) => asset.requestIndex === tempRequest.requestIndex).map((asset: any) => ({
            transferDispoReactivationAssetDetailId: asset.transferDispoReactivationAssetDetailId ? asset.transferDispoReactivationAssetDetailId : 0,
            transDispoReactivationDetailId: tempRequest.transferDispoReactivationDetailId ? tempRequest.transferDispoReactivationDetailId : 0,
            unitNumber: asset.unitNumber || null,
            assetNumber: asset.assetNumber,
            equipmentStatus: asset.eqStatusDesc || null,
            year: asset.modelYear || null,
            description: asset.description || null,
            color: asset.color || null,
            gvw: asset.gvw || null,
            netBookedValue: (typeof asset?.netBookedValue == "number" && asset?.netBookedValue != null) ? asset?.netBookedValue : null,
            monthlyPaymentAmount: (typeof asset?.monthlyAmount == "number" && asset?.netBookedValue != null) ? asset?.monthlyAmount : null,
            monthsRemaining:(asset?.monthRemaining != null) ? asset.monthRemaining : null,
            vinSerialNumber: asset.serialNumber || null,
            licenseNumber: asset.licensePlateNumber || null,
            odometerPerHourMeter: asset.odometerHourMeter || null,
            conditionRating: asset.conditionRating || null,
            conditionComment: asset.conditionComment || null,
            equipmentClass: asset.equipmentClassDesc || null,
            estimatedDispoValue: (asset?.estimatedDispositionPrice !== "") ? parseFloat(getOnlyNumbers(asset?.estimatedDispositionPrice)) : 0,
            gainLoss: asset.disposeGainLoss != null ? asset.disposeGainLoss : null,
            disposalDate: asset.dateDisposed || null,
            model: asset.model || null,
            make: asset.manufacturerName || null,
            disposeCostCenter : asset?.costCenterNo || null,
            attachments: asset.attachments,
            comments: asset.reactivationComments,
            assetType: getAssetType(asset),
            currentLicensePlateNo: asset?.currentLicensePlateNo || null,
            isRequestWriteOffPentaltyExemption: tempRequest?.isWriteOffPenaltyExemption,
            penaltyExemptionReason: tempRequest?.assetDispositionPenaltyExemptionReason,
            dispositionPenaltyFee: globalPenaltyFlag ? parseFloat(getOnlyNumbers(asset?.dispositionPenalityFee ?? 0)) : 0,
            assetStatus: asset?.assetStatus || '',
            isAlreadyReturnedFromFleet: asset?.isAlreadyReturnedFromFleet
        }))
    }

    const getAssetLocation = (tempRequest: any) => {
        return {
            addId: tempRequest?.assetLocationAddressId || 0,
            contactName: tempRequest?.assetLocationContactName || "",
            locationName: tempRequest?.assetLocationName || "",
            addLine1: tempRequest?.assetLocationAddress1 || "",
            addLine2: tempRequest?.assetLocationAddress2 || "",
            assetCity: tempRequest?.assetLocationCity || "",
            assetState: tempRequest?.assetLocationState || "",
            assetZip: tempRequest?.assetLocationZip || "",
            assetPhoneNo: tempRequest?.assetLocationContactPhone || "",
            assetContact: "",
            assetEmail: tempRequest?.assetLocationEmail || ""
        }
    }

    const getAssetDisposition = (tempRequest: any) => {
        return {
            addId: tempRequest?.assetDispositionAddressId || 0,
            DestinationName: tempRequest?.assetDispositionName || "",
            locationName: "",
            addLine1: tempRequest?.assetDispositionAddress1 || "",
            addLine2: tempRequest?.assetDispositionAddress2 || "",
            assetCity: tempRequest?.assetDispositionCity || "",
            assetState: tempRequest?.assetDispositionState || "",
            assetZip: tempRequest?.assetDispositionZip || "",
            assetPhoneNo: tempRequest?.assetDispositionPhone || "",
            thirdPartySalePrice: tempRequest?.assetDispositionSalePrice != "" ? parseFloat(getOnlyNumbers(tempRequest?.assetDispositionSalePrice)) : 0,
            thirdPartyTotalPrice: tempRequest?.assetDispositionTotalPrice !="" ? parseFloat(getOnlyNumbers(tempRequest?.assetDispositionTotalPrice)) : 0,
            assetContact: "",
            assetEmail: ""
        }
    }

    // Creating Transfer data
    if (orderDetails.requestType.label === CONSTANTS.TRANSFER) {
        const transferRequestTemp = transferRequests?.filter((request:any) => getAssets(request)?.length > 0)
        apiObject.transDispoReactivationDetails = transferRequestTemp.map((tempRequest: any) => ({
            transDispoReactivationDetailId: tempRequest.transferDispoReactivationDetailId ? tempRequest.transferDispoReactivationDetailId : 0,
            assignmentTransferTypeId: tempRequest.assignmentTransfer.value,
            processType: "",
            receivingBranchId: tempRequest.costCenter?.value ? parseInt(tempRequest.costCenter.value) : null,
            quantity: getAssets(tempRequest)?.length,
            assets: getAssets(tempRequest)
        }))
    }

    // Creating Transfer data
    if (orderDetails.requestType.label === CONSTANTS.DISPOSITION) {
        const dispositionCart = [];
        const temp = JSON.parse(JSON.stringify(dispositionCartList));
        temp.requestIndex = 0;
        dispositionCart.push(temp);
        apiObject.transDispoReactivationDetails = dispositionCart?.map((tempRequest: any) => ({
            transDispoReactivationDetailId: tempRequest.transferDispoReactivationDetailId ? tempRequest.transferDispoReactivationDetailId : 0,
            assignmentTransferTypeId: 2,
            itemNumber: 0,
            processType: tempRequest?.assetDispositionProcessType,
            dispositionTypeId: tempRequest?.assetDispositionChoiceId,
            dispositionSubTypeId: tempRequest?.assetDispositionSubChoiceId || null,
            receivingBranchId: parseInt(tempRequest?.costCenter?.value) || null,
            receivingBranchManagerEmail: "",
            reasonCodeId: tempRequest?.assetDispositionReasonCodeId || null,
            reasonCodeOther: tempRequest?.assetDispositionReasonCode || null,
            replacementFleetAssetOrderNo: tempRequest?.assetDispositionReplacementFleetAssetOrder,
            replacementFleetAssetNo: tempRequest?.assetDispositionReplacementFleetAsset,
            quantity: getAssets(tempRequest)?.length,
            assets: getAssets(tempRequest),
            assetLocation: getAssetLocation(tempRequest),
            assetDispositionAddress: getAssetDisposition(tempRequest)
        }))
    }

    // Creating Reactivation data
    if (orderDetails.requestType.label === CONSTANTS.REACTIVATION) {
        apiObject.transDispoReactivationDetails = reactivationRequests.map((tempRequest: any) => ({
            transDispoReactivationDetailId: tempRequest.transferDispoReactivationDetailId ? tempRequest.transferDispoReactivationDetailId : 0,
            processType: "",
            quantity: getAssets(tempRequest)?.length,
            assets: getAssets(tempRequest)
        }))
    }

    dispatch(createTransferRequest(apiObject));
}

const APIToReact = (props: any) => {
    const {
        dispatch,
        transferOrderByIdData
    } = props;

    let isDispositionValid = false;
    const orderDetails = {
        selectedBranch: {},
        requestType: {},
        requests: Array(),
        transferDispoReactivationDetailId: '',
        isApprovalOverride: false,
        dispositionPenaltyFlag: false
    };

    let currentBranch = {
        branchNo: transferOrderByIdData?.branchId,
        branchName: transferOrderByIdData?.branchName,
        value: transferOrderByIdData?.costCenter,
        label: transferOrderByIdData?.costCenter,
        text: transferOrderByIdData?.branchId,
        costCenter: transferOrderByIdData?.costCenter.split('-')[0].trim(),
    }

    orderDetails.selectedBranch = JSON.parse(JSON.stringify(currentBranch))
    orderDetails.isApprovalOverride = transferOrderByIdData?.isApprovalOverride
    orderDetails.dispositionPenaltyFlag = transferOrderByIdData?.dispositionPenaltyFlag
    const transferRequestData = Array();
    let dispositionRequestData = {};
    const reactivationRequestData = Array();
    const assetList = Array();
    transferOrderByIdData?.transferDisposeReactivationDetails?.map((order: any, index: any) => {

        if (order?.orderRequestType === CONSTANTS.TRANSFER_REQUEST) {
            orderDetails.requestType = {
                "text": 4,
                "label": "Transfer",
                "value": "Transfer",
                "key": null
            }
            orderDetails.transferDispoReactivationDetailId = order.transferDispoReactivationDetailId;

            order?.assets.forEach((asset: any) => {

                const item = {
                    "assetNumber": asset.assetNo,
                    "unitNumber": asset.equipmentNo,
                    "costCenterNo": "",
                    "equipmentClassDesc": asset.equipmentClass,
                    "equipmentClass": asset.equipmentClass,
                    "description": asset.description,
                    "serialNumber": asset.vinSerialNumber,
                    "dateAcquired": "",
                    "dateDisposed": "",
                    "licenseExpirationDate": "",
                    "model": "",
                    "modelYear": asset.year?.toString(),
                    "eqStatus": "",
                    "licensePlateNumber": asset.licenseNumber,
                    "state": "",
                    "parentAssetNumber": asset.assetNo,
                    "glCategory": asset.assetType === "mower" ? "mower" : asset.assetType,
                    "driverName": "",
                    "driverABNo": 0,
                    "manufacturerID": "",
                    "manufacturerName": "",
                    "eqStatusDesc": asset.equipmentStatus,
                    "vehicleAssignment": "",
                    "netBookedValue": asset.netBookedValue,
                    "monthlyAmount": asset.monthlyPaymentAmt,
                    "monthRemaining": asset.monthRemaining,
                    "isOdometerRequired": asset.assetType == "vehicle" ? true : false,
                    "isLicVinGVWColorRequired": false,
                    "disposeGainLoss": 0,
                    "estimatedDispositionPrice": 0,
                    "isActive": true,
                    "conditionRating": asset.overallConditionRating,
                    "conditionComment": asset.overallConditionComments,
                    "odometerHourMeter": asset.odometerPHourMeter?.toString(),
                    "transferDispoReactivationAssetDetailId": asset.transferDispoReactivationAssetDetailId,
                    "attachments": asset?.assetAttachments?.length > 0 ? JSON.parse(JSON.stringify(asset.assetAttachments)) : [],
                    "requestIndex": index,
                    "requestType": "Transfer",
                    "hide": true,
                    "isExist": true,
                    "isValid": true,
                    "isAlreadyReturnedFromFleet": asset?.isAlreadyReturnedFromFleet,
                    "receivingCostCenter": {
                        "label": order?.recievingCostCenter,
                        "text": order?.recievingCostCenter,
                        "value": order?.recievingBranchId?.toString()
                    },
                }
                assetList.push(item);
            })
            const request = {
                "division": {
                    "label": order?.division,
                    "text": order?.division,
                },
                "costCenter": {
                    "label": order?.recievingCostCenter,
                    "key": order?.recievingBranchId,
                    "text": order?.recievingCostCenter,
                    "value": order?.recievingBranchId?.toString()
                },
                "assignmentTransfer": {
                    "label": order?.assignmentTransferType,
                    "key": order?.assignmentTransferTypeId,
                    "text": order?.assignmentTransferType,
                    "value": order?.assignmentTransferTypeId?.toString()
                },
                "requestIndex": index,
                "requestType": "Transfer",
                "transferDispoReactivationDetailId": order.transferDispoReactivationDetailId
            }
            transferRequestData.push(request);
        } else if (order?.orderRequestType === CONSTANTS.DISPOSITION_REQUEST) {
            //When there is no disposition data for orders created from backend this check we need
            if(order?.dispositionTypeId 
                || order?.assetLocationAddress?.locationName 
                || order?.assetLocationAddress?.contactName
                || order?.assetLocationAddress?.assetEmail
                || order?.assetLocationAddress?.assetPhoneNo
                || order?.assetLocationAddress?.addLine1
                || order?.assetLocationAddress?.assetCity
                || order?.assetLocationAddress?.assetState
                || order?.assetLocationAddress?.assetZip){
                isDispositionValid = true;
            }
            orderDetails.requestType = {
                "text": 5,
                "label": "Disposition",
                "value": "Disposition",
                "key": "1"
            }
            orderDetails.transferDispoReactivationDetailId = order.transferDispoReactivationDetailId;
            let penaltyExemptionReason = "";
            let isPenaltytoggle = false;
            order?.assets.forEach((asset: any) => {

                const item = {
                    "assetNumber": asset.assetNo,
                    "unitNumber": asset.equipmentNo,
                    "costCenterNo": "",
                    "equipmentClassDesc": asset.equipmentClass,
                    "equipmentClass": asset.equipmentClass,
                    "description": asset.description,
                    "serialNumber": asset.vinSerialNumber,
                    "dateDisposed": "",
                    "licenseExpirationDate": "",
                    "model": "",
                    "modelYear": asset.year?.toString(),
                    "eqStatus": "",
                    "licensePlateNumber": asset.licenseNumber,
                    "state": "",
                    "parentAssetNumber": asset.assetNo,
                    "glCategory": asset.assetType === "mower" ? "mower" : asset.assetType,
                    "driverName": "",
                    "driverABNo": 0,
                    "manufacturerID": "",
                    "manufacturerName": asset.make,
                    "eqStatusDesc": asset.equipmentStatus,
                    "vehicleAssignment": "",
                    "netBookedValue": asset.netBookedValue,
                    "monthlyAmount": asset.monthlyPaymentAmt,
                    "monthRemaining": asset.monthRemaining,
                    "isOdometerRequired": asset.assetType == "vehicle" ? true : false,
                    "isLicVinGVWColorRequired": false,
                    "estimatedDispositionPrice": asset?.estimatedDispoValue,
                    "isActive": true,
                    "conditionRating": asset.overallConditionRating,
                    "conditionComment": asset.overallConditionComments,
                    "odometerHourMeter": asset.odometerPHourMeter?.toString(),
                    "transferDispoReactivationAssetDetailId": asset.transferDispoReactivationAssetDetailId,
                    "attachments": asset?.assetAttachments?.length > 0 ? JSON.parse(JSON.stringify(asset.assetAttachments)) : [],
                    "requestIndex": index,
                    "requestType": CONSTANTS.DISPOSITION,
                    "hide": true,
                    "isExist": true,
                    "isValid": true,
                    "dateAcquired" : asset?.acquiredDate,
                    "disposeGainLoss": asset?.disposeGainLoss,
                    "acquisitionCode" : asset?.aquisitionCode,
                    "acquisitionCost": asset?.acquisitionCost,
                    "lifeMonths" : asset?.lifeMonths,
                    "dispositionPenalityFee" : transferOrderByIdData?.dispositionPenaltyFlag ? asset?.dispositionPenaltyFee : 0,
                    "leasedvsOwned" : asset?.leasedvsOwned,
                    "replacementFleetAssetNo" : asset?.replacementFleetAssetNo,
                    "ReplacementFleetAssetOrderNo" : asset?.replacementFleetAssetOrderNo,
                    "assetStatus" : asset?.assetStatus,
                    "showAssetStatus" : asset?.assetStatus?.trim().length > 0 ? true : false,
                    "isAlreadyReturnedFromFleet": asset?.isAlreadyReturnedFromFleet
                }
                penaltyExemptionReason = asset?.penaltyExemptionReason
                isPenaltytoggle = asset?.isRequestWriteOffPentaltyExemption
                assetList.push(item);
            })
            dispositionRequestData = {
                "requestIndex": index,
                "requestType": CONSTANTS.DISPOSITION,
                "requestId": 0,
                "assetDispositionProcessType": order?.processType,
                "assetDispositionProcessTypeId": order?.processType,
                "assetDispositionChoice": order?.dispositionType,
                "assetDispositionChoiceId": order?.dispositionTypeId,
                "assetDispositionSubChoice": order?.dispositionSubType,
                "assetDispositionSubChoiceId": order?.dispositionSubTypeId,
                "assetDispositionReasonCode": order?.reasonCode,
                "assetDispositionReasonCodeId": order?.reasonCodeId,
                "assetDispositionReplacementFleetAssetOrder": order?.replacementFleetAssetOrderNo,
                "assetDispositionReplacementFleetAsset": order?.replacementFleetAssetNo,
                "assetDispositionAddressId": order?.assetDispositionAddress.addId,
                "assetDispositionName": order?.assetDispositionAddress.destinationName,
                "assetDispositionAddress1": order?.assetDispositionAddress.addLine1,
                "assetDispositionAddress2": order?.assetDispositionAddress.addLine2,
                "assetDispositionCity": order?.assetDispositionAddress.assetCity,
                "assetDispositionState": order?.assetDispositionAddress.assetState,
                "assetDispositionZip": order?.assetDispositionAddress.assetZip,
                'assetDispositionPhone': order?.assetDispositionAddress.assetPhoneNo,
                'assetDispositionSalePrice': order?.assetDispositionAddress.thirdPartySalePrice ? formatPrice(order?.assetDispositionAddress.thirdPartySalePrice, 2) : "",
                'assetDispositionTotalPrice': order?.assetDispositionAddress.thirdPartyTotalPrice ? formatPrice(order?.assetDispositionAddress.thirdPartyTotalPrice, 2) : "",
                "assetLocationAddressId": order?.assetLocationAddress?.addId,
                "assetLocationName": order?.assetLocationAddress?.locationName,
                "assetLocationContactName": order?.assetLocationAddress?.contactName,
                "assetLocationEmail": order?.assetLocationAddress?.assetEmail,
                "assetLocationContactPhone": order?.assetLocationAddress?.assetPhoneNo,
                "assetLocationAddress1": order?.assetLocationAddress?.addLine1,
                "assetLocationAddress2": order?.assetLocationAddress?.addLine2,
                "assetLocationCity": order?.assetLocationAddress?.assetCity,
                "assetLocationState": order?.assetLocationAddress?.assetState,
                "assetLocationZip": order?.assetLocationAddress?.assetZip,
                "transferDispoReactivationDetailId": order.transferDispoReactivationDetailId,
                "assetDispositionChoiseAttatmentNote" : DispositionTypeRequiredAttachment(order?.dispositionType),
                "assetDispositionPenaltyExemptionReason" : penaltyExemptionReason,
                "isWriteOffPenaltyExemption" : isPenaltytoggle
            }
        } else if (order?.orderRequestType === CONSTANTS.REACTIVATION_REQUEST) {
            orderDetails.requestType = {
                "text": 6,
                "label": "Reactivation",
                "value": "Reactivation",
                "key": null
            }
            orderDetails.transferDispoReactivationDetailId = order.transferDispoReactivationDetailId;

            order?.assets.forEach((asset: any) => {
                
                const item = {
                    "assetNumber": asset.assetNo,
                    "unitNumber": asset.equipmentNo,
                    "costCenterNo": asset?.disposeCostCenter,
                    "equipmentClassDesc": asset.equipmentClass,
                    "equipmentClass": asset.equipmentClass,
                    "description": asset.description,
                    "serialNumber": asset.vinSerialNumber,
                    "dateAcquired": "",
                    "dateDisposed": asset.disposalDate,
                    "licenseExpirationDate": "",
                    "model": "",
                    "modelYear": asset.year?.toString(),
                    "eqStatus": "",
                    "licensePlateNumber": asset.licenseNumber,
                    "state": "",
                    "parentAssetNumber": asset.assetNo,
                    "glCategory": asset.assetType === "mower" ? "mower" : asset.assetType,
                    "driverName": "",
                    "driverABNo": 0,
                    "manufacturerID": "",
                    "manufacturerName": asset.make,
                    "eqStatusDesc": asset.equipmentStatus,
                    "vehicleAssignment": "",
                    "netBookedValue": asset.netBookedValue,
                    "monthlyAmount": asset.monthlyPaymentAmt,
                    "monthRemaining": asset.monthRemaining,
                    "isOdometerRequired": asset.assetType == "vehicle" ? true : false,
                    "isLicVinGVWColorRequired": false,
                    "disposeGainLoss": asset.gainLoss,
                    "isActive": true,
                    "odometerHourMeter": asset.odometerPHourMeter?.toString(),
                    "transferDispoReactivationAssetDetailId": asset.transferDispoReactivationAssetDetailId,
                    "attachments": asset?.assetAttachments?.length > 0 ? JSON.parse(JSON.stringify(asset.assetAttachments)) : [],
                    "requestIndex": index,
                    "requestType": CONSTANTS.REACTIVATION,
                    "color": asset?.color,
                    "hide": true,
                    "reactivationComments": asset.comments,
                    "currentLicensePlateNo": asset?.currentLicensePlateNo,
                    "isExist": true,
                    "isValid": true,
                    "acquisitionCode" : asset?.aquisitionCode,
                    "acquisitionCost": asset?.acquisitionCost,
                    "lifeMonths" : asset?.lifeMonths,
                    "leasedvsOwned" : asset?.leasedvsOwned,
                    "replacementFleetAssetNo" : asset?.replacementFleetAssetNo,
                    "ReplacementFleetAssetOrderNo" : asset?.replacementFleetAssetOrderNo,
                    "isAlreadyReturnedFromFleet": asset?.isAlreadyReturnedFromFleet
                }
                assetList.push(item);
            })
            const request = {
                "requestIndex": index,
                "requestType": CONSTANTS.REACTIVATION,
                "transferDispoReactivationDetailId": order.transferDispoReactivationDetailId,
                "expand": true
            }
            reactivationRequestData.push(request);
        }
    })

    let orderAttachment = transferOrderByIdData?.orderAttachments?.length > 0 ? JSON.parse(JSON.stringify(transferOrderByIdData?.orderAttachments)) : [];
    dispatch(TransferAction.setTransferOrderNumber(transferOrderByIdData?.orderId));
    dispatch(TransferAction.setSelectedBranch(currentBranch));
    dispatch(TransferAction.setTransferOrderDetails(orderDetails));
    UploadAttachmentsDispatch.dispatchSetAttachments(dispatch)(orderAttachment);
    dispatch(TransferAction.setTransferRequestData(transferRequestData));
    dispatch(TransferAction.setIDisposition(dispositionRequestData));
    dispatch(TransferAction.setReactivationRequestData(reactivationRequestData));
    dispatch(TransferAction.setAssetData(assetList));
    dispatch(setBillOfSaleUrl(transferOrderByIdData?.bosAttachment));
    transferOrderByIdData?.bosAttachment ? dispatch(setIsBillOfSaleCreated(true)) : dispatch(setIsBillOfSaleCreated(false));
    if(isDispositionValid){
        dispatch(TransferAction.setCartIDisposition(dispositionRequestData));
        dispatch(TransferAction.setAssetCartData(assetList));
    }
}



export {
    ReactToAPI,
    APIToReact
}